import { swSettings } from "app/common/services/swSettings";
import type { QuizSplitUseCaseGroup } from "app/pages/activation/components/FirstLandModalProvider/constants";
import { isCompetitiveIntelligenceUser } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { DEFAULT_PARAMS, TRAFFIC_MIN_VALUE } from "./constants";
import { getDefaultLandingState, isBlank, getBusinessLandingState, quizEmailToDomain } from "./utils";

export const resolveQuizLanding = (quiz: QuizSplitUseCaseGroup) => {
    const user = swSettings.user;
    const customData = user?.customData;

    const trafficValue = Number(customData?.quiz?.monthlyVisitsEnrichment);

    const hasMonthlyTraffic = trafficValue >= TRAFFIC_MIN_VALUE;
    const isCiPackage = isCompetitiveIntelligenceUser(swSettings);

    const fallback = () => getDefaultLandingState(quiz, isCiPackage, DEFAULT_PARAMS);

    if (!hasMonthlyTraffic) {
        return fallback();
    }

    const isBlocked = Boolean(customData?.IsDomainDbBlocked);
    const quizWebsite = customData?.quiz?.website as string | undefined;
    const email = (user?.username as string) || "";
    const isCCForced = Boolean(customData?.IsDomainCcForced);

    const key = isCCForced ? quizWebsite : quizEmailToDomain(email);
    const normalizedKey = key?.trim();

    if (!normalizedKey || isBlank(normalizedKey)) {
        return fallback();
    }

    if (!isBlocked && !isCCForced) {
        return getBusinessLandingState(quiz, isCiPackage, { ...DEFAULT_PARAMS, key: normalizedKey });
    }

    return fallback();
};
